<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="ocr_score_wrapper">
          <span class="search_label">识别总分:</span>
          <span class style="font-size: 20px;color:#333;">{{OCRtotalScore}}'</span>
        </div>
        <div class="search_wrapper">
          <span class="search_label">学生</span>
          <Select v-model="selectedStudentId" class="search_item" @on-change="getCardOCRDetail">
            <Option
              v-for="item in studentList"
              :value="item.studentId"
              :key="item.studentId"
            >{{item.studentName+'--'+item.studentId+'--'+"测试编号"+item.testStudentAnswerId}}</Option>
          </Select>
        </div>
        <div class="search_wrapper">
          <span class="search_label">次数</span>
          <Select v-model="testIndex" class="search_item" @on-change="getCardOCRDetail">
            <Option v-for="(item) in testTotal" :value="item" :key="item">第{{item}}次</Option>
          </Select>
        </div>
        <div class="search_wrapper">
          <Button type="primary" size="small" @click="copyData">生成副本</Button>
        </div>
      </div>
      <Table
        class="main_table"
        size="large"
        stripe
        border
        :height="clientHeight - 284"
        :columns="tableHeader"
        :data="tableData"
      >
        <template slot-scope="{ row, index}" slot="answerFormulaPic">
          <viewer :images="[trackUrl + row.image]">
            <img class="track_img" :src="trackUrlItem+ row.answerFormulaPic" />
          </viewer>
        </template>
        <template slot-scope="{ row, index}" slot="replyFormulaPic">
          <viewer :images="[trackUrl + row.image]">
            <img class="track_img" :src="trackUrlItem + row.replyFormulaPic" />
          </viewer>
        </template>
        <template slot-scope="{ row, index}" slot="image">
          <viewer :images="[trackUrl + row.image]">
            <img class="track_img" :src="positionUrl + row.image" />
          </viewer>
        </template>
        <!--<template slot-scope="{ row, index}" slot="track">-->
        <!--<a class="jump_color" :href="trackUrl + row.track" target="_blank">查看</a>-->
        <!--</template>-->
        <template slot-scope="{ row, index}" slot="lastScore">
          <template></template>
          <template></template>
          <a
            class="jump_color_score"
            :style="{color:parseInt(row.lastScore) ? '#0f0' : '#f00'}"
          >{{parseInt(row.lastScore) ? '√' : '×'}}</a>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <span v-if="testIndex>-1" class="hanle_click" @click="selectPlan(row)">复测</span>
          <span v-if="testIndex>-1" class="hanle_click" @click="navToRetestlist(row.id)">查看</span>
          <span v-if="testIndex>-1" class="hanle_click" @click="againCorrect(row.id)">批改</span>
          <span v-if="testIndex==0" class="hanle_click" @click="handleMark(row.id)">标注</span>
          <span
            v-if="testIndex==0"
            class="hanle_click"
            @click="recognitionTestCancelErrorMark(row.id,index)"
          >取消标注</span>
        </template>
        <!--<template slot-scope="{ row, index}" slot="flag">-->
        <!--<a class="jump_color_score" v-if="row.flag != 999" :style="{color:row.flag?'#0f0':'#f00'}">{{row.flag ? '√' : '×'}}</a>-->
        <!--<a class="jump_color" v-if="row.flag == 999">未批改</a>-->
        <!--</template>-->
      </Table>
    </div>
    <Modal v-model="planModal" title="复测方案" @on-ok="planOk">
      <RadioGroup v-model="planListFilter">
        <Scroll>
          <div class="card" v-for="(item,index) of planList" :key="index">
            <Radio :label="item.id">
              <div>{{item.parameterName}}</div>
            </Radio>
          </div>
        </Scroll>
      </RadioGroup>
    </Modal>
    <Modal v-model="markModal" title="标注" @on-ok="recognitionTestErrorMark">
      <div v-if="markModal">
        <RadioGroup v-model="markGroup">
          <div class="mark_card" v-for=" (item,index) of errortype" :key="index">
            <Radio :label="item.label"></Radio>
          </div>
        </RadioGroup>
        <Input v-model="markText" type="textarea" :rows="4" placeholder="备注" />
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  _getCardOCRDetail,
  _getQuestionTypeList,
  _recognitionTestRetest,
  _getConfigList,
  _againCorrect,
  _recognitionTestErrortype,
  _recognitionTestCancelErrorMark,
  _recognitionTestErrorMark,
  _recognitionCopyOriginalData
} from "../api/api";
import { alertTips, dealDate } from "../common/common.js";
import global from "../common/Global";

export default {
  name: "OCRCardDetails",
  components: {},
  data() {
    return {
      clientHeight: 0, // 高度
      trackUrl: global.trackUrl, //轨迹数据前缀
      trackUrlItem: global.trackUrlItem, //蓝牙笔迹图片前缀--小题前缀
      positionUrl: global.positionUrl, // 图片前缀
      selectedStudentId: 0, // 学生id
      testIndex: -1, // 答题卡测试次数
      studentList: [], //学生列表
      testTotal: 0, // 测试次数
      OCRtotalScore: 0, // 识别总分
      questionTypeList: [], // 题目类型列表
      selectPlanItem: {}, // 选中的小题
      totalNum: 0, // 分页总数
      pageNum: 0, // 当前页数
      pageSize: 1000, // 参数配置大小
      subject: "", // 当前的科目
      planList: [], // 方案列表
      planListFilter: "", // 用户选中方案列表
      planModal: false, // 对话框
      markModal: false, // 对话框
      selectMarkId: "", // 选中标注题的id
      markGroup: "",
      markText: "",
      tableScroll: 0,
      errortype: [],
      tableHeader: [
        {
          title: "Id",
          key: "id",
          width: 100
        },
        {
          title: "大题标题",
          key: "title",
          width: 100
        },
        {
          title: "大题类型",
          key: "type",
          filters: [
            { value: "单选题", label: "单选题" },
            { value: "填空题", label: "填空题" },
            { value: "问答题", label: "问答题" },
            { value: "判断题", label: "判断题" },
            { value: "连线题", label: "连线题" },
            { value: "多选题", label: "多选题" }
          ],
          filterMultiple: true,
          filterMethod(value, row) {
            return value == row.type;
          },
          width: 100
        },
        {
          title: "小题序号",
          key: "questionSort",
          width: 100
        },

        {
          title: "识别类型",
          key: "ocrType",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  cursor: "pointer",
                  height: "100%",
                  width: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                },
                domProps: {
                  title: params.row.ocrType
                }
              },
              params.row.ocrType
            );
          },
          width: 100
        },
        {
          title: "识别快照",
          key: "recognitionParameterSnapshot",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  cursor: "pointer",
                  height: "100%",
                  width: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                },
                domProps: {
                  title: params.row.recognitionParameterSnapshot
                }
              },
              params.row.recognitionParameterSnapshot
            );
          },
          width: 100
        },
        {
          title: "录入答案",
          key: "answer",
          width: 100
        },
        {
          title: "录入答案转化",
          key: "answerFormulaPic",
          slot: "answerFormulaPic",
          width: 100
        },
        {
          title: "识别答案",
          key: "reply",
          width: 100
        },
        {
          title: "识别答案转化",
          key: "replyFormulaPic",
          slot: "replyFormulaPic",
          width: 100
        },
        {
          title: "识别结果",
          key: "lastScore",
          slot: "lastScore",
          sortable: true,
          filters: [
            {
              label: "只看对题",
              value: 1
            },
            {
              label: "只看错题",
              value: 2
            }
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            let score = parseInt(row.lastScore);
            if (value === 1) {
              return score > 0;
            } else if (value === 2) {
              return score == 0;
            }
          },
          width: 100
        },
        {
          title: "书写轨迹",
          key: "image",
          slot: "image",
          width: 100
        },
        {
          title: "错误标注",
          key: "errorType",
          width: 100,
          filters: [],
          filterMultiple: false,
          filterMethod(value, row) {
            return value == row.errorTypeNum;
          }
        },
        {
          title: "错误备注",
          key: "errorMemo",
          width: 100
        },

        {
          title: "同题框",
          key: "boxFieldId",
          width: 100
        },
        {
          title: "同组框",
          key: "boxGroupId",
          width: 100
        },
        {
          title: "分值",
          key: "score",
          width: 100
        },
        {
          title: "识别得分",
          key: "lastScore",
          width: 100
        },
        {
          title: "操作",
          key: "action",
          width: 230,
          slot: "action",
          fixed: "right"
        }

        //          {
        //            title: '轨迹数据',
        //            key: 'track',
        //            slot:'track'
        //          },
        //          {
        //            title: '老师批改',
        //            key: 'flag',
        //            slot:'flag'
        //          },
      ],
      tableData: []
    };
  },
  methods: {
    //    重新批改指定小题
    againCorrect(id) {
      const self = this;
      _againCorrect(id).then(res => {
        if (res.code === 0) {
          alertTips("success", "重新批改成功");
          self.getQuestionTypeList();
        }
      });
    },
    //      获取答題卡詳情
    getCardOCRDetail() {
      const self = this;
      let dataInfo = {
        id: self.cardId,
        pagerSheetId: self.pagerSheetId,
        studentId: self.selectedStudentId,
        testNum: self.testIndex
      };
      _getCardOCRDetail(dataInfo).then(res => {
        if (res.code === 0) {
          let dealArr = [];
          self.OCRtotalScore = 0;
          if (res.data.sectionInfoList && res.data.sectionInfoList.length > 0) {
            res.data.sectionInfoList.forEach((section, sectionIndex) => {
              if (section.details && section.details.length > 0) {
                section.details.forEach((list, listIndex) => {
                  if (list.items && list.items.length > 0) {
                    list.items.forEach((item, index) => {
                      self.OCRtotalScore =
                        self.OCRtotalScore + item.lastScore / 100;
                      dealArr.push({
                        id: item.id,
                        title: section.title,
                        type: item.questionType
                          ? self.questionTypeList[item.questionType - 1].name
                          : self.questionTypeList[section.type - 1].name,
                        questionSort: `${list.questionNo}${
                          item.questionOffset ? "." + item.questionOffset : ""
                        }`,
                        answer: item.answer,
                        answerFormulaPic: list.answerFormulaPic,
                        reply: item.reply,
                        replyFormulaPic: list.replyFormulaPic,
                        track: item.track,
                        image: item.image,
                        flag: item.flag,
                        boxFieldId: item.boxFieldId,
                        boxGroupId: item.boxGroupId,
                        errorType: item.errorType,
                        errorTypeNum: this.errortype.findIndex(
                          item_ => item_.label == item.errorType
                        ),
                        errorMemo: item.errorMemo,
                        recognitionParameterSnapshot: item.recognitionParameterSnapshot
                          ? item.recognitionParameterSnapshot
                          : list.recognitionParameterSnapshot,
                        score: `${list.score / 100}分`,
                        lastScore: `${item.lastScore / 100}分`,
                        ocrType: item.ocrType
                      });
                    });
                  }
                });
              }
            });
          }
          self.tableData = dealArr;
          self.selectedStudentId = res.data.currentStudentId;
          self.studentList = res.data.studentInfoList.map(item => {
            item.testStudentAnswerId = res.data.testStudentAnswerId;
            return item;
          });
          let testTotal = [-1];
          if (res.data.duplicate) testTotal.push(0);
          for (let index = 0; index < res.data.maxTestNumber; index++) {
            testTotal.push(index + 1);
          }
          self.testTotal = testTotal;
        } else {
        }
      });
    },
    // 获取题目类型列表
    getQuestionTypeList() {
      const self = this;
      _getQuestionTypeList().then(res => {
        if (res.code === 0) {
          let dealArr = res.data.sort(function(m, n) {
            return m.id - n.id;
          });
          self.questionTypeList = dealArr;
          self.getCardOCRDetail();
        } else {
          alertTips("warning", res.message);
        }
      });
    }, //获取错题类型
    recognitionTestErrortype() {
      _recognitionTestErrortype().then(res => {
        if (res.code == 0) {
          this.errortype = res.data.map((item, index) => {
            return {
              label: item,
              value: index
            };
          });
          this.tableHeader[
            this.tableHeader.findIndex(item => item.title == "错误标注")
          ].filters = this.errortype;
        }
      });
    }, //取消标注
    recognitionTestCancelErrorMark(id, index) {
      _recognitionTestCancelErrorMark({ data: id }).then(res => {
        if (res.code === 0) {
          alertTips("success", "取消标注成功");
          this.tableData[index].errorType = "";
          this.tableData[index].errorMemo = "";
        }
      });
    }, //复制原始数据
    copyData() {
      _recognitionCopyOriginalData({
        studentId: this.selectedStudentId,
        classSheetId: this.cardId
      }).then(res => {
        if (res.code === 0) {
          alertTips("success", "成功");
        }
      });
    },
    //错误标注
    recognitionTestErrorMark() {
      _recognitionTestErrorMark({
        id: this.selectMarkId,
        errorType: this.markGroup,
        errorMark: this.markText
      }).then(res => {
        if (res.code === 0) {
          this.tableData[
            this.tableData.findIndex(item => item.id == this.selectMarkId)
          ].errorType = this.markGroup;
          this.tableData[
            this.tableData.findIndex(item => item.id == this.selectMarkId)
          ].errorMemo = this.markText;
          alertTips("success", "标注成功");
          this.markGroup = "";
          this.markText = "";
          this.selectMarkId = "";
        }
      });
    }, //手动选择
    handleMark(id) {
      this.selectMarkId = id;
      this.markModal = true;
    },
    //     获取高度
    getClientHeight() {
      this.clientHeight = document.documentElement.clientHeight;
    },
    //  复测列表确定
    planOk() {
      this.recognitionTestRetest();
    },
    // 选中小题
    selectPlan(data) {
      this.selectPlanItem = data;
      this.questionTypeList.filter(item => item.name == data.type)[0].id;
      this.selectPlanItem.questionType = this.questionTypeList.filter(
        item => item.name == data.type
      )[0].id;
      this.planList = [];
      this.getConfigList();
    },
    // 获取配置列表
    getConfigList() {
      const self = this;
      let paramsInfo = {
        questionType: self.selectPlanItem.questionType,
        subject: self.subject,
        page: self.pageNum,
        size: self.pageSize,
        sort: "updateTime,desc"
      };
      _getConfigList({ params: paramsInfo }).then(res => {
        if (res.code === 0) {
          self.planList = res.data.content;
          console.log(self.planList);

          self.planModal = true;
          self.totalNum = res.data.total;
        } else {
          alertTips("warning", res.message);
        }
      });
    },
    //小题复测
    recognitionTestRetest() {
      _recognitionTestRetest({
        id: this.selectPlanItem.id,
        configureIds: [this.planListFilter]
      }).then(res => {
        if (res.code === 0) {
          this.$Message.success("成功");
          this.planListFilter = "";
        }
      });
    },
    planBottom() {
      // console.log("拉到底");
      // this.pageNum += 1;
      // return this.getConfigList();
    },
    //小题复测
    navToRetestlist(id) {
      this.$router.push(`/OCRCardItem?id=${id}`);
    }
  },
  activated() {
    if (this.$route.meta.ifDoFresh) {
      //重置ifDoFresh
      this.$route.meta.ifDoFresh = false; //获取列表数据方法第一参数为是否重置搜索条件和页数
      document
        .getElementsByClassName("ivu-table-body")[0]
        .scroll(0, this.tableScroll);
    } else {
      this.cardId = this.$route.params.id;
      this.pagerSheetId = this.$route.query.sheetId;
      this.subject = this.$route.query.subject;
      this.recognitionTestErrortype();
      this.getClientHeight();
      this.getQuestionTypeList();
      window.addEventListener("resize", this.getClientHeight);
      document
        .getElementsByClassName("ivu-table-body")[0]
        .addEventListener("scroll", event => {
          this.tableScroll = event.target.scrollTop;
        });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped>
.ctrl-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.search_wrapper {
  width: 33.3%;
  display: flex;
  margin-right: 16px;
  height: 100%;
}
.search_wrapper:last-child {
  margin-right: 0;
}
.search_wrapper .search_label {
  display: inline-block;
  margin-right: 8px;
  line-height: 32px;
}
.search_wrapper .search_item {
  flex: 1;
  text-align: left;
}
.track_img {
  max-height: 80px;
  cursor: pointer;
}
.jump_color_score {
  padding: 15px 10px 15px 0;
  color: #2d8cf0;
  font-size: 36px;
  cursor: pointer;
}
.ocr_score_wrapper {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  margin-right: 60px;
}
.hanle_click {
  color: #2d8cf0;
  cursor: pointer;
}
.card {
  padding: 10px;
  margin: 10px;
}
.card label {
  width: 100%;
  display: flex;
  align-items: center;
}
.card label div {
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mark_card {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/OCRCardDetails.vue